import {
  put,
  select,
  takeEvery,
  delay,
  race,
  call,
  take,
  cancel,
  takeLatest
} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {
  DELETE_BAD_DRIVER_RATING,
  DELETE_BAD_DRIVER_RATING_ERROR,
  DELETE_BAD_DRIVER_RATING_SUCCESS,
  GET_BAD_DRIVER_RATING,
  GET_BAD_DRIVER_RATING_ERROR,
  GET_BAD_DRIVER_RATING_SUCCESS,
  GET_BAD_ORDER,
  GET_BAD_ORDER_SUCCESS,
  RATE_BAD_DRIVER,
  RATE_BAD_DRIVER_ERROR,
  RATE_BAD_DRIVER_SUCCESS,
  STOP_BAD_ORDER_DETAIL_JOB,
  RUN_BAD_ORDER_DETAIL_JOB,
  SET_BAD_ORDER_DETAIL_NOTES,
  SET_BAD_LARGE_ORDER_STATUS,
  SET_BAD_ORDER_DETAIL_LOADING,
  UPDATE_BAD_DRIVER_RATING,
  UPDATE_BAD_DRIVER_RATING_ERROR,
  UPDATE_BAD_DRIVER_RATING_SUCCESS,
  UPDATE_BAD_STATUS
} from 'store/bookADriver/bookADriverDetails/action';
import {
  changeLargeOrderStatusApi,
  getBADOrderApi,
  postBADDetailsNotesApi
} from 'helpers/services/api/bookADrive';
import {
  deleteDriverRatingApi,
  getDriverRatingApi,
  rateDriverApi,
  updateDriverRatingApi
} from 'helpers/services/api/ordersV2';
import {getStorageToken} from 'helpers/localStorage/authStorage';

const GET_ORDER_DETAIL_INTERVAL = 60000;

export function* getBADOrder(payload) {
  while (true) {
    try {
      const {data} = yield getBADOrderApi(payload);

      if (data) {
        yield put(GET_BAD_ORDER_SUCCESS(data));
        yield put(SET_BAD_ORDER_DETAIL_LOADING(false));
      }
    } catch (error) {
      console.log('SAGA ERROR', error);
      yield put(SET_BAD_ORDER_DETAIL_LOADING(false));
      return false;
    }
    yield delay(GET_ORDER_DETAIL_INTERVAL);
  }
}

function* runGetOrderDetailsJob({payload}) {
  try {
    const isOnline = yield select(
      (state) => state.globalNotificationsReducer?.isNetworkOnline
    );
    const userData = yield select((state) => state.user.userData);
    const {token} = getStorageToken();
    if (!isOnline || !token || !userData.role || userData.role === 'sudo') {
      return;
    }

    const {stop} = yield race({
      job: call(() => getBADOrder(payload)),
      stop: take(STOP_BAD_ORDER_DETAIL_JOB)
    });

    if (stop) {
      yield cancel();
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* postBADDetailsNotes({payload}) {
  try {
    const data = yield postBADDetailsNotesApi(payload.id, {
      notes: payload.notes
    });
    if (data) {
      toast.success('Internal notes has been saved!');
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* changeLargeOrderStatus({payload}) {
  try {
    const {data} = yield changeLargeOrderStatusApi(payload.id, {
      status: payload.status
    });
    if (data) {
      yield put(UPDATE_BAD_STATUS(payload.status));
      toast.success('Status has been changed!');
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* rateBadDriver({payload}) {
  try {
    const {data} = yield rateDriverApi(payload);

    if (data?.data) {
      yield put(RATE_BAD_DRIVER_SUCCESS(data?.data));
      toast.success('Driver rating submitted successfully');
    }
  } catch (error) {
    yield put(RATE_BAD_DRIVER_ERROR(error));
    console.log('SAGA ERROR', error);
  }
}

function* getBadDriverRating({payload}) {
  try {
    const {data} = yield getDriverRatingApi(payload);

    if (data?.data) {
      yield put(GET_BAD_DRIVER_RATING_SUCCESS(data?.data));
    } else {
      yield put(GET_BAD_DRIVER_RATING_SUCCESS(null));
    }
  } catch (error) {
    if (error?.response?.status === 404) {
      yield put(GET_BAD_DRIVER_RATING_SUCCESS(null));
    } else {
      yield put(GET_BAD_DRIVER_RATING_ERROR(error));
      console.log('SAGA ERROR', error);
    }
  }
}

function* updateBadDriverRating({payload: {deliveryId, ...data}}) {
  try {
    const {data: responseData} = yield updateDriverRatingApi(deliveryId, data);

    if (responseData?.data) {
      yield put(UPDATE_BAD_DRIVER_RATING_SUCCESS(responseData?.data));
      toast.success('Driver rating updated successfully');
    }
  } catch (error) {
    yield put(UPDATE_BAD_DRIVER_RATING_ERROR(error));
    console.log('SAGA ERROR', error);
  }
}

function* deleteBadDriverRating({payload}) {
  try {
    yield deleteDriverRatingApi(payload);
    yield put(DELETE_BAD_DRIVER_RATING_SUCCESS());
    yield put(GET_BAD_DRIVER_RATING(payload));
    toast.success('Driver rating removed successfully');
  } catch (error) {
    yield put(DELETE_BAD_DRIVER_RATING_ERROR(error));
    console.log('SAGA ERROR', error);
  }
}

function* orderBADDetailsSaga() {
  yield takeEvery(GET_BAD_ORDER, getBADOrder);
  yield takeEvery(SET_BAD_ORDER_DETAIL_NOTES, postBADDetailsNotes);
  yield takeEvery(SET_BAD_LARGE_ORDER_STATUS, changeLargeOrderStatus);
  yield takeEvery(RATE_BAD_DRIVER, rateBadDriver);
  yield takeEvery(GET_BAD_DRIVER_RATING, getBadDriverRating);
  yield takeEvery(UPDATE_BAD_DRIVER_RATING, updateBadDriverRating);
  yield takeEvery(DELETE_BAD_DRIVER_RATING, deleteBadDriverRating);
  yield takeLatest(RUN_BAD_ORDER_DETAIL_JOB, runGetOrderDetailsJob);
}

export default orderBADDetailsSaga;
